import { Overline, Card } from "./shared";

export const CompetitorsResult = ({ r }) => (
  <div data-testid="bb-result-competitors">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5">
      {(r.competitors || []).map((c) => (
        <Card key={c.name}>
          <div className="font-display font-extrabold text-xl tracking-tight">{c.name}</div>
          <div className="font-mono text-xs text-[#52525b] mt-1">{c.positioning}</div>
          <div className="font-mono text-xs mt-2">💰 {c.pricing}</div>
          <div className="text-xs mt-3"><span className="text-[#ff3b30]">Weakness:</span> {c.weakness}</div>
          <div className="text-xs mt-2 font-bold">→ {c.your_angle}</div>
        </Card>
      ))}
    </div>
    <Card className="bg-[#0a0a0a] text-white">
      <Overline>The gap · your strategy</Overline>
      <p className="text-sm text-[#d4d4d8]">{r.market_gap}</p>
      <p className="text-sm text-[#d4d4d8] mt-2">{r.differentiation_strategy}</p>
      <p className="text-sm mt-3 text-[#ff3b30]">🏰 Moat: {r.moat_idea}</p>
    </Card>
  </div>
);
